// 3rd party imports
import * as React from 'react';
import { observer } from 'mobx-react';

// mobx
import { AuthState } from 'sources';
import { useStores } from '../../hooks';

interface RenderWrapperProps {
  component: any;
  render?: any;
  renderProps?: any;
}

export const RenderWrapper: React.FunctionComponent<RenderWrapperProps> = observer(
  ({ component, render, renderProps }) => {
    const { userAuth } = useStores();

    switch (userAuth.authenticated) {
      case AuthState.UNKNOWN:
        return null;

      case AuthState.FALSE:
        userAuth.initiateLogin(true);

        return null;

      case AuthState.TRUE:
        // eslint-disable-next-line no-case-declarations
        const C = component;

        return render ? render(renderProps) : <C {...renderProps} />;
    }
  },
);
